import React__default from 'react';
import styles from '../../components/cells/onboardingnextup/onboardingnextup.module.scss.js';
import classNames from './../../external_lib/classnames/index.js';
import HorizonText, { TextVariant } from '../../base/HorizonText/index.js';
import Button, { ButtonVariant, ButtonSize } from '../../atoms/button/index.js';
import img from '../../assets/icons/onboarding-company-profile.svg.js';
import img$2 from '../../assets/icons/onboarding-configure-locations.svg.js';
import img$1 from '../../assets/icons/onboarding-create-brands.svg.js';
import img$6 from '../../assets/icons/onboarding-invite-users.svg.js';
import img$3 from '../../assets/icons/onboarding-preview-menus.svg.js';
import img$4 from '../../assets/icons/onboarding-taxes-charges.svg.js';
import img$5 from '../../assets/icons/onboarding-rtgl.svg.js';
import img$9 from '../../assets/icons/right-arrow.svg.js';
import img$7 from '../../assets/images/stepper-background.svg.js';
import img$8 from '../../assets/icons/complete.svg.js';
var _a;
var NextUpStates;
(function (NextUpStates) {
  NextUpStates["COMPLETE_COMPANY_DETAILS"] = "COMPLETE_COMPANY_DETAILS";
  NextUpStates["CREATE_BRANDS"] = "CREATE_BRANDS";
  NextUpStates["CONFIGURE_LOCATIONS"] = "CONFIGURE_LOCATIONS";
  NextUpStates["CONFIGURE_MENUS"] = "CONFIGURE_MENUS";
  NextUpStates["TAXES_CHARGES"] = "TAXES_CHARGES";
  NextUpStates["GO_LIVE_ON_LOCATIONS"] = "GO_LIVE_ON_LOCATIONS";
  NextUpStates["INVITE_USERS"] = "INVITE_USERS";
})(NextUpStates || (NextUpStates = {}));
var NEXT_UP_CARD_DATA = (_a = {}, _a[NextUpStates.COMPLETE_COMPANY_DETAILS] = {
  title: 'Complete company details',
  subTitle: "Add your restaurant's basic information",
  actionButtonText: 'Start',
  icon: img
}, _a[NextUpStates.CREATE_BRANDS] = {
  title: 'Create brands',
  subTitle: "Add all your restaurant's brands",
  actionButtonText: 'Start',
  icon: img$1
}, _a[NextUpStates.CONFIGURE_LOCATIONS] = {
  title: 'Configure locations',
  subTitle: 'Add the locations where your restaurant operates',
  actionButtonText: 'Start',
  icon: img$2
}, _a[NextUpStates.CONFIGURE_MENUS] = {
  title: 'Configure menus',
  subTitle: 'Create menus for your locations',
  actionButtonText: 'Preview',
  icon: img$3
}, _a[NextUpStates.TAXES_CHARGES] = {
  title: 'Configure taxes and charges',
  subTitle: 'Configure all taxes and charges that are applicable on your menu items',
  actionButtonText: 'Preview',
  icon: img$4
}, _a[NextUpStates.GO_LIVE_ON_LOCATIONS] = {
  title: 'Go live on all locations',
  subTitle: 'Go live on ordering platforms with all your locations',
  actionButtonText: 'Start',
  icon: img$5
}, _a[NextUpStates.INVITE_USERS] = {
  title: 'Invite users',
  subTitle: 'Invite staff to your account',
  actionButtonText: 'Start',
  icon: img$6
}, _a);
function OnboardingNextUp(_a) {
  var _b = _a.className,
    className = _b === void 0 ? '' : _b,
    _c = _a.currentState,
    currentState = _c === void 0 ? NextUpStates.COMPLETE_COMPANY_DETAILS : _c,
    _d = _a.onCtaClick,
    onCtaClick = _d === void 0 ? function () {} : _d,
    _e = _a.isComplete,
    isComplete = _e === void 0 ? false : _e;
  var nextUpData = NEXT_UP_CARD_DATA[currentState];
  return React__default.createElement("div", {
    className: classNames(styles.OnboardingNextUp, className)
  }, React__default.createElement("img", {
    className: styles.StepperBackground,
    src: img$7,
    alt: "stepper-background"
  }), isComplete ? React__default.createElement("div", {
    className: styles.OnboardingComplete
  }, React__default.createElement("img", {
    className: styles.OnboardingCompleteIcon,
    src: img$8,
    alt: "onboarding-complete"
  }), React__default.createElement(HorizonText, {
    className: styles.OnboardingCompleteText,
    variant: TextVariant.HEADING3
  }, "All steps have been completed")) : React__default.createElement(React__default.Fragment, null, React__default.createElement(HorizonText, {
    className: styles.OnboardingNextUpHeadingText,
    variant: TextVariant.HEADING5
  }, "Next Up"), React__default.createElement("div", {
    className: styles.NextUpCard
  }, React__default.createElement("div", {
    className: styles.NextUpCardLeft
  }, React__default.createElement("img", {
    className: styles.NextUpCardIcon,
    src: nextUpData.icon,
    alt: nextUpData.title
  }), React__default.createElement(HorizonText, {
    className: styles.NextUpCardTitle,
    variant: TextVariant.HEADING4
  }, nextUpData.title), React__default.createElement(HorizonText, {
    className: styles.NextUpCardSubTitle,
    variant: TextVariant.BODY1
  }, nextUpData.subTitle)), React__default.createElement("div", {
    className: styles.NextUpCardRight
  }, React__default.createElement(Button, {
    onClick: function () {
      return onCtaClick(currentState);
    },
    variant: ButtonVariant.Link,
    size: ButtonSize.LG,
    rightIcon: React__default.createElement("img", {
      src: img$9,
      alt: "cta"
    })
  }, nextUpData.actionButtonText)))));
}
export { NextUpStates, OnboardingNextUp as default };
//# sourceMappingURL=index.js.map
